import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { logError } from './lib/logger'
import { installPrintExpand } from './lib/printExpand'
import './theme/fonts.css'
import './theme/tokens.css'
import './theme/base.css'
import './theme/print.css'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

// Boot guard: any synchronous failure before React can mount (a bad print hook,
// a router init throw from extension-tampered history/location) is written into
// the page rather than left as a blank white screen.
try {
  installPrintExpand()
  createRoot(root).render(
    <StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </StrictMode>
  )
} catch (err) {
  logError('boot failure', err)
  root.textContent = `This page could not start: ${
    err instanceof Error ? err.message : String(err)
  }. A browser extension may be interfering. Try an incognito window with extensions off, or another browser.`
}
